// extracted by mini-css-extract-plugin
module.exports = {"captionContainer":"captions_captionContainer_1Ag","captions":"captions_captions_HWE"};